import { createReducer } from '@reduxjs/toolkit'
import * as tollingAccountsActions from '../actions/tollingAccounts'
import { APIData, APIStatus } from '../axiosConfiguration'
import { TollingAccountData } from '../type/tollingAccounts'

type tollingAccountState = {
  tollingAccounts: APIData<TollingAccountData>
}

const initialState: tollingAccountState = {
  tollingAccounts: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(tollingAccountsActions.getTollingAccounts.fulfilled, (state, action) => {
      state.tollingAccounts.status = APIStatus.FULFILLED
      state.tollingAccounts.data = action.payload
    })
    .addCase(tollingAccountsActions.getTollingAccounts.rejected, (state, action) => {
      state.tollingAccounts.status = APIStatus.REJECTED
      state.tollingAccounts.error = action.payload
    })
    .addCase(tollingAccountsActions.getTollingAccounts.pending, (state) => {
      state.tollingAccounts.status = APIStatus.PENDING
    })
})
